<template>
    <section class="hero is-fullheight">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <transition name="fade">
                        <div v-if="error.status" class="notification is-danger">
                            {{ error.message }}
                        </div>
                        <div v-if="success.status" class="notification is-success">
                            {{ success.message }}
                        </div>
                    </transition>
                    <h3 class="title has-text-grey">Create New Password!</h3>
                    <p class="subtitle has-text-grey">Use the form below to create new password.</p>
                    <div class="box">
                        <form>
                            <div class="field">
                                <div class="control">
                                    <input v-model="data.email"
                                           v-bind:class="{ 'is-danger': error.status }"
                                           class="input"
                                           type="email"
                                           placeholder="Enter email"
                                           required=""
                                           autofocus="">
                                    <p v-if="error.errors.email" class="help is-danger">{{ error.errors.email[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input v-model="data.password"
                                           v-bind:class="{ 'is-danger': error.status }"
                                           class="input"
                                           type="password"
                                           placeholder="Enter new password"
                                           required=""
                                           autofocus="">
                                    <p v-if="error.errors.password" class="help is-danger">{{ error.errors.password[0] }}</p>
                                </div>
                            </div>
                            <div class="field">
                                <div class="control">
                                    <input v-model="data.password_confirmation"
                                           v-bind:class="{ 'is-danger': error.status }"
                                           class="input"
                                           type="password"
                                           placeholder="Confirm password"
                                           required=""
                                           autofocus="">
                                </div>
                            </div>
                            <button @click.prevent="resetPassword"
                                    class="button is-block is-danger is-large is-fullwidth"
                                    v-bind:class="{'is-loading': loading}">Reset password</button>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    import apiAuth from '../../api/apiAuth'
    export default {
        data() {
            return {
                data:{
                    password: '',
                    password_confirmation: '',
                    email: '',
                    token: this.$route.params.token
                },
                error: {
                    status: false,
                    message: '',
                    errors: {
                        password: '',
                        password_confirmation: '',
                        email: ''
                    }
                },
                success: {
                    status: false,
                    message: ''
                },
                loading: false
            }
        },
        methods: {
            resetPassword() {
                this.loading = true
                apiAuth.passwordReset(this.data)
                    .then((response) => {
                        this.success.message = response.data
                        this.loading = false
                        this.error.status = false
                        this.success.status = true
                        for(var i in this.data) this.data[i] = ''
                    })
                    .catch((err) => {
                        this.error.status = true
                        this.success.status = false
                        this.loading = false
                        if ( err.response && err.response.status === 422 ) {
                            this.error.message = err.response.statusText
                            this.error.errors.password = err.response.data.password
                            this.error.errors.password_confirmation = err.response.data.password_confirmation
                            this.error.errors.email = err.response.data.email
                        } else if ( err.response && err.response.status === 401 ) {
                            this.error.message = err.response.data[0]
                        } else {
                            this.error.message = 'Connection error!'
                        }
                    })
            }
        }

    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Auth/PasswordReset.vue